import type { HyperlinkModel } from '../../permalinks/hyperlinkModel';
import type { LocalStyles } from '@paperbits/common/styles';
import identifier from '../../utils/identifier';

/**
 * Button widget model.
 */
export class ButtonModel {
    /**
     * Label on the button.
     */
    public label: string;

    /**
     * Label on the button.
     */
    public ariaLabel?: string;

    /**
     * Assigned hyperlink.
     */
    public hyperlink: HyperlinkModel;

    /**
     * Button local styles.
     */
    public styles: LocalStyles;

    /**
     * Keys of user roles.
     */
    public roles?: string[];

    /**
     * Icon key.
     */
    public iconKey?: string;

    /**
     * Unique identifier.
     */
    public id: string;

    /**
     * Identify button from content download page
     */
    public formDownload?: boolean;

    constructor() {
        this.label = 'Button';
        this.styles = { appearance: 'components/button/default' };
        this.id = identifier();
    }
}
